import { Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, firstValueFrom, Subscription } from 'rxjs';
import { Product, SearchKey } from 'src/typings';
import { ProductService } from '../product.service';
import { SearchKeyCreateComponent } from '../search-key-create/search-key-create.component';

@Component({
  selector: 'app-search-key-manager',
  templateUrl: './search-key-manager.component.html',
  styleUrls: ['./search-key-manager.component.scss']
})
export class SearchKeyManagerComponent implements OnDestroy {
  @Input() set product(payload: Product | undefined) {
    this._product = payload;
    if (
      this.product &&
      (this.product.searchKeys == undefined || this.product.searchKeys.length === 0)
    ) {
      this.loadKeys();
    }
  }

  private _product: Product | undefined;

  get product() {
    return this._product;
  }

  addSearchKeySubscription: Subscription | undefined;

  removeSearchKeySubscription: Subscription | undefined;

  columnsToDisplay = ['key', 'menu'];

  loadingRows: SearchKey[] = [];

  constructor(private dialog: MatDialog, private productService: ProductService) {
    this.addSearchKeySubscription = this.productService.addSearchKeyGW.subscribe((data) => {
      if (!this.product) return;
      this.product.searchKeys?.push(data);
      this.updateView();
    });

    this.removeSearchKeySubscription = this.productService.removeSearchKeyGW.subscribe((data) => {
      if (!this.product) return;
      const index = this.product.searchKeys?.findIndex((row) => row.key === data.key);
      if (index !== undefined && index > -1) {
        this.product.searchKeys?.splice(index, 1);
        this.updateView();
      }
    });
  }

  isLoading(key: string): boolean {
    const index = this.loadingRows.findIndex((row) => row.key === key);
    return index > -1;
  }

  updateView() {
    if (!this.product || !this.product.searchKeys) return;
    this.rows.next(this.product.searchKeys);
  }

  get rows() {
    const data = new BehaviorSubject<SearchKey[]>([]);
    if (!this.product || !this.product.searchKeys) {
      data.next([]);
    } else {
      data.next(this.product.searchKeys);
    }
    return data;
  }

  ngOnDestroy() {
    this.addSearchKeySubscription?.unsubscribe();
    this.removeSearchKeySubscription?.unsubscribe();
  }

  openDialog() {
    const dialogRef = this.dialog.open(SearchKeyCreateComponent);
    const subs = dialogRef.componentInstance.addEvent.subscribe((key) => {
      this.addKey(key);
      dialogRef.close();
      subs.unsubscribe();
    });
  }

  addLoading(key: string) {
    this.loadingRows.push({ key });
  }

  removeLoading(key: string) {
    const index = this.loadingRows.findIndex((row) => row.key === key);
    this.loadingRows.splice(index, 1);
  }

  async addKey(key: string) {
    if (!this.product) return;
    this.addLoading(key);
    await firstValueFrom(
      this.productService.addSearchKey({
        productId: this.product.id,
        key
      })
    );
    this.removeLoading(key);
  }

  async removeKey(key: string) {
    if (!this.product) return;
    const confirm = window.confirm(`Удалить ${key}?`);
    if (!confirm) return;
    this.addLoading(key);
    await firstValueFrom(
      this.productService.removeSearchKey({
        productId: this.product.id,
        key
      })
    );
    this.removeLoading(key);
  }

  async loadKeys() {
    if (!this.product) return;
    this.product.searchKeys = await firstValueFrom(
      this.productService.getSearchKeys(this.product.id)
    );
  }
}
